import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v0/auth';

export class AuthenticationService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  signIn(params: types.SignInParameters): Promise<types.TokenResponse> {
    throw new Error('Method not implemented.');
  }
  signOut(params: types.SignOutParameters): Promise<types.SignOutResponse> {
    throw new Error('Method not implemented.');
  }

  refreshToken(params: types.RefreshTokenParameters): Promise<types.TokenResponse> {
    throw new Error('Method not implemented.');
  }
  validateToken(params: types.ValidateTokenParameters): Promise<types.ValidateTokenResponse> {
    throw new Error('Method not implemented.');
  }
  checkProjectAdminRights(params: types.CheckProjectAdminRightsParameters): Promise<void> {
    throw new Error('Method not implemented.');
  }
}
